import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { ChevronLeftCircle, FileQuestion } from "lucide-react";

export default function RouteNotFound() {
  const { t } = useTranslation();

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Card className="shadow-none border-none place-content-center h-full">
      <CardHeader>
        <CardTitle className="justify-center items-center text-5xl flex flex-col gap-4">
          <FileQuestion size={64} />
          {t("pageNotFound.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="my-4">
        <p className="text-center text-2xl w-3/4 mx-auto">
          {t("pageNotFound.description")}
        </p>
      </CardContent>
      <CardFooter className="justify-center">
        <Button onClick={handleGoBack}>
          <ChevronLeftCircle size={16} className="mr-3" />
          {t("pageNotFound.backButton")}
        </Button>
      </CardFooter>
    </Card>
  );
}
